import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <footer>
      <div className="footer_heading">

      </div>
    </footer>
  )
}

export default Footer